"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _paginationButton = _interopRequireDefault(require("./paginationButton"));

var _paginationUtils = require("./paginationUtils");

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _airbnbPropTypes = require("airbnb-prop-types");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _deprecatedProp = _interopRequireDefault(require("../helpers/deprecated-prop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_CUSTOM_LABELS = ['Previous', 'Next'];

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      maxPagesCount = _ref.maxPagesCount,
      onPageClick = _ref.onPageClick,
      hidden = _ref.hidden,
      showPages = _ref.showPages,
      fluid = _ref.fluid,
      _ref$pagesGenerator = _ref.pagesGenerator,
      pagesGenerator = _ref$pagesGenerator === void 0 ? _paginationUtils.generatePages : _ref$pagesGenerator,
      showNavLabels = _ref.showNavLabels,
      customNavLabels = _ref.customNavLabels,
      collapsed = _ref.collapsed,
      props = _objectWithoutProperties(_ref, ["currentPage", "totalPages", "maxPagesCount", "onPageClick", "hidden", "showPages", "fluid", "pagesGenerator", "showNavLabels", "customNavLabels", "collapsed"]);

  var onNextPageClick = function onNextPageClick() {
    return onPageClick(currentPage + 1);
  };

  var onPreviousPageClick = function onPreviousPageClick() {
    return onPageClick(currentPage - 1);
  };

  var isFirstPage = currentPage === 1;
  var isLastPage = currentPage === totalPages;
  var paginationStyles = ['co-pagination', {
    'co-pagination--fluid': fluid
  }];
  var pages = collapsed ? totalPages : pagesGenerator({
    currentPage: currentPage,
    totalPages: totalPages,
    maxPagesCount: maxPagesCount
  });
  return hidden ? null : _react.default.createElement(_styler.default, {
    classNames: paginationStyles
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), _react.default.createElement("ul", null, _react.default.createElement(_paginationButton.default, {
      disabled: isFirstPage,
      onClick: onPreviousPageClick,
      ariaLabel: customNavLabels[0]
    }, _react.default.createElement(_icon.default, {
      name: _icon.default.CHEVRON_LEFT
    }), showNavLabels && " ".concat(customNavLabels[0])), showPages ? createPages(pages, currentPage, onPageClick) : null, _react.default.createElement(_paginationButton.default, {
      disabled: isLastPage,
      onClick: onNextPageClick,
      ariaLabel: customNavLabels[1]
    }, showNavLabels && "".concat(customNavLabels[1], " "), _react.default.createElement(_icon.default, {
      name: _icon.default.CHEVRON_RIGHT
    }))));
  });
};

function createPages(pages, currentPage, onClick) {
  var _this = this;

  if (Array.isArray(pages)) {
    return pages.map(function (page, index) {
      var isPageNumber = Number.isInteger(page);
      var clickHandler = onClick.bind(_this, page);
      var selected = currentPage === page;
      return _react.default.createElement(_paginationButton.default, {
        key: index,
        selected: selected,
        disabled: !isPageNumber,
        onClick: clickHandler
      }, page.toString());
    });
  }

  return _react.default.createElement("li", null, "".concat(currentPage, " / ").concat(pages));
}

var exclusiveProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('collapsed', 'showNavLabels');
Pagination.propTypes = {
  currentPage: _propTypes.number,
  totalPages: _propTypes.number.isRequired,
  maxPagesCount: _propTypes.number,
  showPages: _propTypes.bool,

  /** @@!!!@@ */
  pagesGenerator: (0, _deprecatedProp.default)(_propTypes.func, 'Deprecated.'),

  /** @@!!!@@ */
  hidden: (0, _deprecatedProp.default)(_propTypes.bool, 'Deprecated.'),
  onPageClick: _propTypes.func.isRequired,
  fluid: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@showNavLabels@@ @@collapsed@@ */
  showNavLabels: exclusiveProps,
  // mutually exclusive
  customNavLabels: _propTypes.array,

  /** {bool} Mutually exclusive props: @@showNavLabels@@ @@collapsed@@ */
  collapsed: exclusiveProps
};
Pagination.defaultProps = {
  currentPage: 1,
  maxPagesCount: 3,
  showPages: true,
  fluid: false,
  showNavLabels: true,
  customNavLabels: DEFAULT_CUSTOM_LABELS
};
var _default = Pagination;
exports.default = _default;
Pagination.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Pagination",
  "props": {
    "pagesGenerator": {
      "defaultValue": {
        "value": "generatePages",
        "computed": true
      },
      "type": {
        "name": "custom",
        "raw": "deprecated(func, 'Deprecated.')"
      },
      "required": false,
      "description": "@@!!!@@"
    },
    "currentPage": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "maxPagesCount": {
      "defaultValue": {
        "value": "3",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "showPages": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fluid": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "showNavLabels": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "exclusiveProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@showNavLabels@@ @@collapsed@@"
    },
    "customNavLabels": {
      "defaultValue": {
        "value": "['Previous', 'Next']",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "totalPages": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "hidden": {
      "type": {
        "name": "custom",
        "raw": "deprecated(bool, 'Deprecated.')"
      },
      "required": false,
      "description": "@@!!!@@"
    },
    "onPageClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "collapsed": {
      "type": {
        "name": "custom",
        "raw": "exclusiveProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@showNavLabels@@ @@collapsed@@"
    }
  }
};